import { Component } from "solid-js";

export type NavIconName =
  | "fleet"
  | "instances"
  | "proxy"
  | "gateway"
  | "dashboard"
  | "accounts"
  | "credentials"
  | "notifications"
  | "bundle"
  | "diagnostics"
  | "components"
  | "health"
  | "observability"
  | "audit"
  | "sessions"
  | "roles"
  | "home"
  | "sync"
  | "deployments"
  | "users"
  | "key"
  | "logs"
  | "settings"
  | "sun"
  | "moon"
  | "logout"
  | "rocket"
  | "analytics";

interface NavIconProps {
  name: NavIconName;
  size?: number;
  class?: string;
}

/** Inline SVG icons for navigation - no external dependencies */
export const NavIcon: Component<NavIconProps> = (props) => {
  const s = () => props.size ?? 18;

  const paths: Record<NavIconName, string> = {
    fleet:
      "M4 6h16M4 12h16M4 18h16",
    instances:
      "M9 17H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4M12 17v4M8 21h8",
    proxy:
      "M12 2a4 4 0 0 0-4 4v1H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2V6a4 4 0 0 0-4-4m0 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    gateway:
      "M12 2v6m0 8v6M2 12h6m8 0h6M7.05 7.05l1.41 1.41m7.08 7.08 1.41 1.41m0-9.9-1.41 1.41M8.46 15.54l-1.41 1.41",
    dashboard:
      "M3 12h4v8H3zm7-8h4v16h-4zm7 4h4v12h-4z",
    accounts:
      "M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm4 3h10M7 14h6",
    credentials:
      "M12 2a4 4 0 0 0-3 6.65V12h6V8.65A4 4 0 0 0 12 2m-1 14v4h2v-4m-5 0v2h2v-2m6 0v2h2v-2",
    notifications:
      "M18 8A6 6 0 1 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0",
    bundle:
      "M12 3l8 4.5v9L12 21l-8-4.5v-9zm0 9V21M4 7.5l8 4.5m0-4.5L20 7.5",
    diagnostics:
      "M11 4a1 1 0 1 0 2 0 1 1 0 0 0-2 0M4 12h4l3-8 2 16 3-8h4",
    components:
      "M12 2l4 4-4 4-4-4zm6 6l4 4-4 4-4-4zm-12 0l4 4-4 4-4-4zm6 6l4 4-4 4-4-4z",
    health:
      "M19.5 13.572 12 21l-7.5-7.428A5 5 0 1 1 12 6.006a5 5 0 1 1 7.5 7.566",
    observability:
      "M3 3v18h18M7 16l4-8 4 4 4-10",
    audit:
      "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-6 9 2 2 4-4",
    sessions:
      "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3",
    roles:
      "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10M9 12l2 2 4-4",
    home:
      "M3 12l2-2m0 0 7-7 7 7m-14 0v7a2 2 0 0 0 2 2h3m7-11v7a2 2 0 0 0-2 2h-3m-4 0h4",
    sync:
      "M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3",
    deployments:
      "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5",
    users:
      "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m13 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
    key:
      "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4",
    logs:
      "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8m8 4H8m2-8H8",
    settings:
      "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    sun:
      "M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72 1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10",
    moon:
      "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79",
    logout:
      "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4m7 14 5-5-5-5m5 5H9",
    rocket:
      "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2",
    analytics:
      "M3 3v18h18M7 17v-4m4 4v-8m4 8V9m4 8v-6",
  };

  return (
    <svg
      width={s()}
      height={s()}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class={props.class}
      style={{ "flex-shrink": "0" }}
    >
      <path d={paths[props.name] || paths.dashboard} />
    </svg>
  );
};
